var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0965 0.389671L3.9365 7.29967L2.0365 5.26967C1.6865 4.93967 1.1365 4.91967 0.736504 5.19967C0.346504 5.48967 0.236503 5.99967 0.476503 6.40967L2.7265 10.0697C2.9465 10.4097 3.3265 10.6197 3.7565 10.6197C4.1665 10.6197 4.5565 10.4097 4.7765 10.0697C5.1365 9.59967 12.0065 1.40967 12.0065 1.40967C12.9065 0.489671 11.8165 -0.320329 11.0965 0.379671V0.389671Z",
    fill: "#079455"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIcon);
export default __webpack_public_path__ + "static/media/correct_icon.f4774e5787db8de9552ecc9d81101e6d.svg";
export { ForwardRef as ReactComponent };